module.exports = __webpack_public_path__ + "static/img/4674_phase_function_Paper_Points.0569747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4674_phase_function_Paper_Points.png
// module id = OfY+
// module chunks = 0